import React, { useEffect, useState } from "react";
import "../styles/offers.css";
import { API_BASE_URL } from "../api/api";

const OfferPage = () => {
  const [activeCoupons, setActiveCoupons] = useState([]);
  const [expiredCoupons, setExpiredCoupons] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCoupons();
  }, []);

  const fetchCoupons = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/coupons`);

      const data = await response.json();

      // active first
      const active = data.filter(
        (coupon) => !coupon.expired && coupon.status === 1,
      );

      // expired below
      const expired = data.filter(
        (coupon) => coupon.expired || coupon.status === 0,
      );

      setActiveCoupons(active);
      setExpiredCoupons(expired);
    } catch (error) {
      console.error("Error fetching coupons:", error);
    } finally {
      setLoading(false);
    }
  };

  const copyCoupon = (code) => {
    navigator.clipboard.writeText(code);
    alert(`Coupon ${code} copied!`);
  };

  if (loading) {
    return (
      <div className="offers-loader">
        <div className="loader"></div>
        <p>Loading offers...</p>
      </div>
    );
  }

  return (
    <div className="offer-page">
      {/* TOP BANNER */}

      <div className="offer-banner">
        <h2>🔥 Best Deals For You</h2>
        <p>Save more with exclusive restaurant coupons</p>
      </div>

      {/* ACTIVE COUPONS */}

      <div className="offer-section">
        <h3>🟢 Active Offers</h3>

        <div className="offer-grid">
          {activeCoupons.length > 0 ? (
            activeCoupons.map((coupon) => (
              <div className="offer-card active-card" key={coupon.id}>
                <div className="offer-left">
                  <span className="offer-badge">
                    {coupon.type === "percent"
                      ? `${coupon.value}% OFF`
                      : `₹${coupon.value} OFF`}
                  </span>

                  <h4>{coupon.code}</h4>

                  <p>Min Order ₹{coupon.min_amount || 0}</p>

                  {coupon.expiry_date && (
                    <small>
                      Valid till{" "}
                      {new Date(coupon.expiry_date).toLocaleDateString()}
                    </small>
                  )}
                </div>

                <button onClick={() => copyCoupon(coupon.code)}>Copy</button>
              </div>
            ))
          ) : (
            <div className="no-offers">
              <h4>No active offers 😢</h4>
            </div>
          )}
        </div>
      </div>

      {/* EXPIRED COUPONS */}

      {expiredCoupons.length > 0 && (
        <div className="offer-section expired-section">
          <h3>⏳ Expired Offers</h3>

          <div className="offer-grid">
            {expiredCoupons.map((coupon) => (
              <div className="offer-card expired-card" key={coupon.id}>
                <div className="offer-left">
                  <span className="offer-badge expired-badge">Expired</span>

                  <h4>{coupon.code}</h4>

                  <p>
                    {coupon.type === "percent"
                      ? `${coupon.value}% OFF`
                      : `₹${coupon.value} OFF`}
                  </p>

                  {coupon.expiry_date && (
                    <small>
                      Expired on{" "}
                      {new Date(coupon.expiry_date).toLocaleDateString()}
                    </small>
                  )}
                </div>

                <button className="expired-btn" disabled>
                  Expired
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default OfferPage;
